export interface OperationLike {
  serviceName?: string;
  page?: string;
  action?: string;
  name?: string;
  description?: string;
}

interface EnumOption {
  label: string;
  value: string;
}

// 操作名称中文映射
const actionNameMap: Record<string, string> = {
  view: "查看",
  create: "创建",
  update: "更新",
  delete: "删除",
  export: "导出",
  import: "导入",
  "*": "全部操作",
  all: "全部操作",
};

/**
 * 格式化权限名称
 * 格式：微服务中文名 + 页面名 + "页面" + 操作名（中文）
 */
const formatPermissionName = (
  selectedOperation: OperationLike | null | undefined,
  serviceOptions: EnumOption[]
): string => {
  if (!selectedOperation) {
    return "-";
  }

  const { serviceName, page, action } = selectedOperation;

  // 获取微服务的中文名
  let serviceLabel = serviceName || "";
  if (serviceName) {
    const serviceOption = serviceOptions.find((opt) => opt.value === serviceName);
    if (serviceOption) {
      serviceLabel = serviceOption.label || serviceName;
    }
  }

  // 获取页面名，格式为 "xxx页面"
  let pageLabel = "";
  if (page) {
    pageLabel = `${page}页面`;
  }

  // 获取操作的中文名
  const actionLabel = actionNameMap[action || ""] || action || "";

  // 拼接：微服务中文名 + 页面名 + "页面" + 操作名
  const parts = [serviceLabel, pageLabel, actionLabel].filter((part) => part);
  return parts.join("") || "-";
};

export const getPermissionDescriptionData = (
  selectedNodeCode: string | undefined,
  selectedOperation: OperationLike | null | undefined,
  serviceOptions: EnumOption[] = []
) => {
  return [
    { key: "code", label: "权限代码", value: selectedNodeCode || "-" },
    {
      key: "name",
      label: "权限名称",
      value: formatPermissionName(selectedOperation, serviceOptions),
    },
  ];
};


